import React, { Component } from 'react';
import { Row, Col, Form, Input, Tooltip, Drawer,  } from 'antd';
import dayjs from 'dayjs';

import * as constants from '../constants';

import common from '../../../common';

const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 12 },
}

class ReportHeader extends Component {

    state = {
        visible: false,
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ReportHeader', key);
    }
    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };
    onClose = () => {
        this.setState({
            visible: false,
        });
    };

    render() {

        let itemLayout = formItemLayout;

        const firstPart = <>

            <Form.Item label={this.label("Name")} {...itemLayout}>
                <Input size="small" value={this.props.username} readOnly={true} />
            </Form.Item>
            <Form.Item label={this.label("PersonnelNumber")} {...itemLayout}>
                <Input size="small" value={this.props.personnelNumber} readOnly={true} />
            </Form.Item>
            <Form.Item label={this.label("Department")} {...itemLayout}>
                <Input size="small" value={this.props.department} readOnly={true} />
            </Form.Item>
            <Form.Item label={this.label("Company")} {...itemLayout}>
                <Input size="small" value={this.props.company} readOnly={true} />
            </Form.Item>
            <Form.Item label={this.label("JobDescription")} {...itemLayout}>
                <Input size="small" value={this.props.jobDescription} readOnly={true} />
            </Form.Item>
        </>
        const secondPart = <>
            <Form.Item label={this.label("Supervisor")} {...itemLayout}>
                <Input size="small" value={this.props.supervisor} readOnly={true} />
            </Form.Item>
            <Form.Item label={this.label("SubmittedOn")} {...itemLayout}>
                <Input size="small" value={this.props.submittedOn ? dayjs(this.props.submittedOn).format('DD-MM-YYYY') : ''} readOnly={true} />
            </Form.Item>
            <Form.Item label={this.label("Status")} {...itemLayout}>
                <Input size="small" value={this.props.status} readOnly={true} />
            </Form.Item>
            <Form.Item label={this.label("ApprovedBy")} {...itemLayout}>
                <Input size="small" value={this.props.approvedBy} readOnly={true} />
            </Form.Item>
            <Form.Item label={this.label("ApprovedOn")} {...itemLayout}>
                <Input size="small" value={this.props.approvedOn ? dayjs(this.props.approvedOn).format('DD-MM-YYYY') : ''} readOnly={true} />
            </Form.Item>
        </>

        return (
            <div className='report-header'>
                <Row justify="start" gutter={8}>

                    <Col span={12} >
                        {firstPart}
                    </Col>
                    <Col span={12} >
                        {secondPart}
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ReportHeader;